<template>
  <div>
    <v-app-bar color="transparent" elevation="0" height="90px">
      <div class="container d-flex align-center position-relative">
        <img src="/img/logos/clan.png" alt="cc logo" style="width: 60px"/>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "DefaultDesktopNav",
}
</script>

